/* @flow */
export const AdminRoles = {
  superintendent: 'Superintendent',
  principal: 'Principal',
  vicePrincipal: 'Vice Principal',
  techCoordinator: 'Technical Coordinator',
  ITDirector: 'IT Director',
  other: 'Other',
};

export const AdminRoleOptions: Array<*> = Object.keys(AdminRoles).map(key => {
  return { label: AdminRoles[key], value: key };
});

export const VIDEO_URL = 'https://www.youtube.com/embed/1V9ADCGhuo4';
